import { useRef } from "react";
import LaserFlow from "../LaserFlow/LaserFlow";
import "./LaserLoader.css";

const THEME = {
  laser: "#A855F7",
  glow: "rgba(217,70,239,1)",
  glowSoft: "rgba(217,70,239,0.45)",
  border: "rgba(168,85,247,0.9)",
  text: "#D946EF",
  textShadow:
    "0 0 10px rgba(217,70,239,0.9), 0 0 28px rgba(168,85,247,0.6)"
};

function LoadingText() {
  return (
    <div className="laser-loading-text">
      LOADING…
    </div>
  );
}

export default function LaserLoader() {
  const revealImgRef = useRef(null);

  return (
    <div
      className="laser-loader-wrapper"
      onMouseMove={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        revealImgRef.current?.style.setProperty("--mx", `${x}px`);
        revealImgRef.current?.style.setProperty("--my", `${y}px`);
      }}
      onMouseLeave={() => {
        revealImgRef.current?.style.setProperty("--mx", "-9999px");
        revealImgRef.current?.style.setProperty("--my", "-9999px");
      }}
    >
      {/* LASER */}
      <LaserFlow
        color={THEME.laser}
        mouseTiltStrength={0}
        mouseSmoothTime={0}
        fogIntensity={0.75}
        fogScale={0.28}
        fogFallSpeed={0.35}
        verticalSizing={5.8}
        decay={2.3}
        flowSpeed={0.42}
        wispIntensity={8.5}
        verticalBeamOffset={-0.055}
      />

      {/* LOADING BOX */}
      <div className="laser-loading-box">
        <div className="laser-seam" />
        <LoadingText />
      </div>

      {/* BACKGROUND IMAGE */}
      <img
        ref={revealImgRef}
        src="/images/image.jpeg"
        alt=""
        className="laser-reveal-img"
      />
    </div>
  );
}